import { Button } from "@/components/ui/button";
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import Icon from "@/icons";
import { useEffect, useState } from "react";

export const ChangeEmail = ({ children, setEmail }: { children: React.ReactNode, setEmail: any }) => {

    const [isOpen, setIsOpen] = useState(false);
    const [email, setEmailC] = useState("");
    const [password, setPassword] = useState("");
    const [emailError, setEmailError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
        if (!email) { setEmailError(""); setDisabled(true); return; }
        if (emailRegex.test(email)) { setEmailError(""); setDisabled(false); }
        else { setEmailError("Please enter a valid email address"); setDisabled(true); }
    }, [email]);

    useEffect(() => {
        if (!password) { setPasswordError(""); setDisabled(true); return; }
        if (String(password).length >= 6) { setPasswordError(""); setDisabled(false); }
        else { setPasswordError("Password must be at least 6 characters long"); setDisabled(true); }
    }, [password]);

    const requestEmail = async () => {
        setDisabled(true);
        const response = await fetch('__SITE_BASE__/api/me/email/change', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email, password }),
        });
        const data = await response.json();
        if (!data.success) {
            setPasswordError(data?.errors?.password);
            setEmailError(data?.errors?.email);
            setDisabled(false);
            if(!data?.errors?.password && !data?.errors?.email) setEmailError(data.message);
            return;
        }
        setPassword("");
        setPasswordError("");
        setEmailError("");
        setEmail(email);
        setIsOpen(false);
    }
    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger>
                {children}
            </DialogTrigger>
            <DialogContent className="bg-brand-dark text-white border-0 max-w-96 sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Change Email</DialogTitle>
                    <DialogDescription>
                        <div className="bg-brand-green text-white rounded-full w-8 h-8 flex items-center justify-center absolute -top-4 -right-4">
                            <Icon name="email" size="16" />
                        </div>
                        <div className="items-center justify-center flex w-full flex-col mt-4 mb-4">
                            <p className="font-bold text-lg">Change your email address</p>
                            <p className="text-center">Enter your new email address and password to confirm the change.</p>
                        </div>

                        <div className="flex flex-col space-y-4">
                            {emailError && <div className="text-red-500">{emailError}</div>}
                            <Input
                                type="email"
                                placeholder="Email"
                                value={email}
                                className="rounded-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300"
                                onChange={(e) => setEmailC(e.target.value)}
                            />
                            {passwordError && <div className="text-red-500">{passwordError}</div>}
                            <Input
                                type="password"
                                placeholder="Password"
                                value={password}
                                className="rounded-lg bg-brand-darkest border-r-0 border-l-0 border-t-0 border-b-brand-green placeholder:text-gray-300"
                                onChange={(e) => setPassword(e.target.value)}
                            />

                        </div>
                        <Button
                            className="bg-brand-green px-5 py-2 w-full mt-4 rounded-lg text-white font-semibold hover:bg-green-500"
                            onClick={requestEmail}
                            disabled={disabled}
                        >
                            Change Email
                        </Button>

                    </DialogDescription>
                </DialogHeader>
            </DialogContent>
        </Dialog>

    );
};
